import { PatientsBymistokenOrderAction } from "./patients.bymistoken.order.types";

export const patientsBymistokenOrderRequest = (order: number[]): PatientsBymistokenOrderAction => ({ type: 'PATIENTS_BYMISTOKEN_ORDER_REQUEST', params: { order } })

export const patientsBymistokenOrderSuccess = (): PatientsBymistokenOrderAction => ({ type: 'PATIENTS_BYMISTOKEN_ORDER_REQUEST' })

export const patientsBymistokenOrderFailure = () => ({ type: 'PATIENTS_BYMISTOKEN_ORDER_FAILURE' } as const)